
            const data = {"name":"arrow","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M3.333 8h9.334M8 3.333 12.667 8 8 12.666\" _stroke=\"#7D92A7\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#7D92A7"}],"stopColors":[]}}
        
                    module.exports = data
                    